// extracted by mini-css-extract-plugin
module.exports = {"share":"index_share__zolgd","main":"index_main__Wbypu","tips":"index_tips__gDh_W","picture":"index_picture__1iofH","center":"index_center__34_4r"};